module.exports = __webpack_public_path__ + "img/中国南海水产研究所.9dbb6105.jpg";